import { LooseAutocomplete, TODO } from '@b2b/types/core';
import angular, { IHttpInterceptor, IQService, IRootScopeService } from 'angular';

ConflictInterceptorFactory.$inject = ['$q', '$rootScope'];

export interface ConflictInterceptorError {
  type: LooseAutocomplete<
    'object_lock' | 'object_lock_system' | 'object_lock_no_permission' | 'object_lock_save_no_permission'
  >;
  errorData: TODO;
}

function ConflictInterceptorFactory($q: IQService, $rootScope: IRootScopeService) {
  return {
    request: function (config) {
      return config;
    },
    requestError: function (rejection) {
      console.log('ConflictInterceptorFactory::requestError', rejection);

      return $q.reject(rejection);
    },
    response: function (response) {
      return response;
    },
    responseError: function (response) {
      const code = response.data?.code || '';
      const error = response.data?.error || '';
      const errorData = response.data?.errorData || {};
      let preventPropagation = false;

      if (response.config.ignoreConflict) {
        return $q.reject(response);
      }

      switch (response.status) {
        case 409:
          if (code) {
            switch (code) {
              case 9048:
                if (response.config && response.config.method && response.config.method.toLowerCase() === 'delete') {
                  preventPropagation = true;
                } else {
                  $rootScope.$broadcast('ConflictInterceptorFactory::error', {
                    type: 'object_lock',
                    errorData: errorData,
                  });
                }
                break;
              case 9050:
                $rootScope.$broadcast('ConflictInterceptorFactory::error', {
                  type: 'object_lock_system',
                  errorData: errorData,
                });
                break;
              case 9049:
              case 9051:
                $rootScope.$broadcast('ConflictInterceptorFactory::error', {
                  type: 'object_lock_no_permission',
                  errorData: errorData,
                });
                break;
              case 9052:
                // do not propagate this error code. it may cause double modals to pop up
                preventPropagation = true;
                $rootScope.$broadcast('ConflictInterceptorFactory::error', {
                  type: 'object_lock_save_no_permission',
                  errorData: errorData,
                });
                break;
              default:
                $rootScope.$broadcast('ConflictInterceptorFactory::error', { type: code + ' ' + error });
            }
          } else {
            $rootScope.$broadcast('ConflictInterceptorFactory::error', { type: code + ' ' + error });
          }
          break;
      }

      if (!preventPropagation) {
        return $q.reject(response);
      }
    } as TODO,
  } satisfies IHttpInterceptor;
}

export const ConflictInterceptorFactoryModule = angular
  .module('acme.common.factory.conflictInterceptor', ['ui.bootstrap'])
  .factory('ConflictInterceptorFactory', ConflictInterceptorFactory).name;
